<template>
  <div class="container">
    <div class="searchForm">
      <div class="leftWrap">
        <b-field label="From">
          <b-datetimepicker v-model="formProps.dateFrom" placeholder="Click to select..." :date-formatter="dateFormatter" editable>
            <template slot="left">
              <button class="button is-primary" @click="formProps.dateFrom = new Date()">
                <b-icon icon="clock"></b-icon>
                <span>Now</span>
              </button>
            </template>
            <template slot="right">
              <button class="button is-danger" @click="formProps.dateFrom = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </template>
          </b-datetimepicker>
        </b-field>
        <b-field label="To">
          <b-datetimepicker v-model="formProps.dateTo" placeholder="Click to select..." :date-formatter="dateFormatter" editable>
            <template slot="left">
              <button class="button is-primary" @click="formProps.dateTo = new Date()">
                <b-icon icon="clock"></b-icon>
                <span>Now</span>
              </button>
            </template>
            <template slot="right">
              <button class="button is-danger" @click="formProps.dateTo = null">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </template>
          </b-datetimepicker>
        </b-field>
        <button class="button is-primary" @click="GetItems()">Submit</button>
      </div>
      <div class="rightWrap">
        <form class="dataFilters">
          <b-field label="Company">
            <b-select placeholder="Select a Customer" v-model="formProps.customerId">
              <option v-for="customer in customers" :value="customer.disctools_id" :key="customer.disctools_id">{{ customer.customer_name }}</option>
            </b-select>
          </b-field>
          <b-field label="Formula">
            <b-input v-model="formula"></b-input>
          </b-field>
        </form>
      </div>
    </div>
    <b-table :data="recogData">
      <b-table-column field="dateTime" label="Date/Time" v-slot="props" sortable>
        {{ props.row.dateTime }}
      </b-table-column>
      <b-table-column field="duration" label="Duration" v-slot="props" sortable>
        {{ props.row.duration }}
      </b-table-column>
      <b-table-column field="cost" label="Cost" v-slot="props" sortable>
        {{ calculateCost(props.row.duration) }}
      </b-table-column>
    </b-table>
  </div>
</template>

<style scoped>
.searchForm {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.tableButtonsWrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 250px;
  margin-right: 0;
  margin-left: auto;
  gap: 10px;
  margin-bottom: 10px;
}

.rightWrap form {
  width: unset;
}

span.select {
  width: 100%;
}

.searchForm select {
  width: 100%;
}
</style>

<script>
const axios = require("axios");

export default {
  data: function () {
    return {
      recogData: [],
      formProps: {},
      customers: [],
      isLoading: true,
      formula: "/ 15 * 0.009",
      apiUrl: "https://api.jeak.co.uk",
      dateoptions: { year: "numeric", month: "short", day: "numberic" },
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      let from = this.dateFormatter(this.formProps.dateFrom);
      let to = this.dateFormatter(this.formProps.dateTo);
      let request = `${this.apiUrl}/stats/recog?dateFrom=${from}&dateTo=${to}&customerId=${this.formProps.customerId}`;
      axios.get(request, config).then((response) => {
        this.recogData = response.data.data;
        this.isLoading = false;
      });
    },
    GetCustomers: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios.get(this.apiUrl + "/customers", config).then((response) => {
        this.customers = [{ disctools_id: 0, customer_name: "All Customers" }];
        let bufferedthis = this;
        response.data.data.forEach(function (value) {
          bufferedthis.customers.push(value);
        });
        //this.customers = response.data.data;
      });
    },
    dateFormatter(dt) {
      let date = new Date(dt),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    calculateCost(duration) {
      let cost = eval(`${duration} ${this.formula}`);
      return cost;
    },
  },
  mounted() {
    this.GetCustomers();
  },
};
</script>
